import { CurrentUser } from "#root/queries/users";
import { createAction } from "@reduxjs/toolkit";

export interface LoginPayload {
  email: string;
  password: string;
  tenantId?: string;
  superAdmin?: boolean;
}

export interface SignUpSuccessPayload {
  email: string;
  role: string;
}

export interface RequestResetPasswordPayload {
  email: string;
  tenantId: string;
}

export interface OrganizationRequestPayload {
  email: string;
}

export const loginUser = createAction<LoginPayload>("authentication/login");
export const loginSuccess = createAction("authentication/login/success");
export const loginFailure = createAction<{ error: string }>("authentication/login/failure");

export const logout = createAction("authentication/logout");

export const refreshToken = createAction("authentication/refreshToken");
export const refreshTokenSuccess = createAction("authentication/refreshToken/success");
export const refreshTokenFailure = createAction<{ error: string }>("authentication/refreshToken/failure");

export const loadCurrentUser = createAction('authentication/loadCurrentUser');
export const loadCurrentUserSuccess = createAction<CurrentUser>('authentication/loadCurrentUser/success');
export const loadCurrentUserFailure = createAction<{ error: string }>('authentication/loadCurrentUser/failure');


export const requestResetPassword = createAction<RequestResetPasswordPayload>("authentication/requestResetPassword");
export const requestResetPasswordSuccess = createAction("authentication/requestResetPassword/success");
export const requestResetPasswordFailure = createAction<{ error: string }>("authentication/requestResetPassword/failure");
export const clearForgotPasswordState = createAction("CLEAR_FORGOT_PASSWORD_STATE");
